var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0913 14H5.90903C5.40694 14 5 13.5523 5 13C5 12.4477 5.40694 12 5.90903 12H18.091C18.5931 12 19 12.4477 19 13C19 13.5523 18.5934 14 18.0913 14Z",
    fill: "#00DCB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0913 8H5.90903C5.40694 8 5 7.55233 5 7C5 6.44767 5.40694 6 5.90903 6H18.091C18.5931 6 19 6.44767 19 7C19.0003 7.55233 18.5934 8 18.0913 8Z",
    fill: "#00DCB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0913 2H5.90903C5.40694 2 5 1.55233 5 1C5 0.447667 5.40694 0 5.90903 0H18.091C18.5931 0 19 0.447667 19 1C19 1.55233 18.5934 2 18.0913 2Z",
    fill: "#00DCB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42444 2.84887C2.21113 2.84887 2.84887 2.21113 2.84887 1.42444C2.84887 0.637742 2.21113 0 1.42444 0C0.637742 0 0 0.637742 0 1.42444C0 2.21113 0.637742 2.84887 1.42444 2.84887Z",
    fill: "#00DCB4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42444 8.84887C2.21113 8.84887 2.84887 8.21113 2.84887 7.42444C2.84887 6.63774 2.21113 6 1.42444 6C0.637742 6 0 6.63774 0 7.42444C0 8.21113 0.637742 8.84887 1.42444 8.84887Z",
    fill: "#00DCB4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42444 14.8489C2.21113 14.8489 2.84887 14.2111 2.84887 13.4244C2.84887 12.6377 2.21113 12 1.42444 12C0.637742 12 0 12.6377 0 13.4244C0 14.2111 0.637742 14.8489 1.42444 14.8489Z",
    fill: "#00DCB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list-view.f6de112b59805fb829db04ee2bf4e308.svg";
export { ForwardRef as ReactComponent };